/**
 * True when running in a non-production environment (local, dev, test, staging).
 * When true, GTM and other analytics should not be loaded or sent.
 */
const NON_PROD_ENVS = ["dev", "development", "test", "stag", "staging", "local"];

export function isDevEnv(): boolean {
  const env = (process.env.ENVIRONMENT || process.env.ENV || "").toLowerCase();
  if (env && NON_PROD_ENVS.includes(env)) return true;
  if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "prod") return true;
  return false;
}

/**
 * Paths that must not send anything to GTM/GA4.
 * - Legacy `/match` + `/match/:id` redirects (not `/matches`)
 * - Legacy `/matchdetail` redirect
 * - `/admin` (admin app / stub)
 */
export function isAnalyticsPathExcluded(pathname?: string | null): boolean {
  const raw =
    pathname != null && String(pathname) !== ""
      ? String(pathname)
      : typeof window !== "undefined"
        ? window.location.pathname
        : "";
  const path = raw.toLowerCase();
  if (!path) return false;
  if (path === "/admin" || path.startsWith("/admin/")) return true;
  // Exact `/match` or `/match/...` — must not match `/matches`.
  if (path === "/match" || path.startsWith("/match/")) return true;
  if (path === "/matchdetail" || path.startsWith("/matchdetail/")) return true;
  return false;
}
